// extracted by mini-css-extract-plugin
export var white = "empty-screen-module--white--Cc7k5";
export var wrapper = "empty-screen-module--wrapper--OSp0P";